<template>

<app-wrapper>

	<app-steps :total="3" :current="stage" class="book-steps" />

    <com-design v-show="stage === 1" v-on:back="$emit('cancel')" v-on:proceed="onProceed" />
    <com-campaign v-show="stage === 2" v-on:back="onBack" v-on:proceed="onProceed" />
    <com-payment :duration="inputs.duration" :inputs="inputs" v-show="stage === 3" v-on:back="onBack" v-on:proceed="$emit('success')" />

</app-wrapper>

</template>

<script>

import comDesign from './book/Design'
import comCampaign from './book/Campaign'
import comPayment from './book/Payment'

import Vue from 'vue'

export default {

    components: {
        'com-design': comDesign,
        'com-campaign': comCampaign,
        'com-payment': comPayment
    },

    data: function() {

        return {
            is: {
                verifying: false
            },
            inputs: {},
            stage: 1
        }

    },

    created: function() {

        if (this.$route.meta.cancel || this.$route.meta.success) {

            this.inputs = this.$store.getters['memory']['adverts/book'] || {}

            this.stage = 3

        }

    },

    methods: {

        onBack: function() {

            this.stage--

        },

        onProceed: function(inputs) {

            this.$_.each(inputs, function(value, key) {

                Vue.set(this.inputs, key, value)

            }.bind(this))

			this.stage++
			
            this.$store.commit('memory/add', {
                name: 'adverts/book',
                value: this.inputs
            })

        }

    }

}

</script>

<style scoped>

.book-steps {
    margin-top: -10px!important;
}

.is-mobile .book-steps {
    margin-top: 0px!important;
}

</style>